var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLastCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6666 18.002V23.8334C17.6666 24.5494 18.5099 24.932 19.0487 24.4606L25.7153 18.6272C26.0948 18.2952 26.0948 17.7049 25.7153 17.3729L19.0487 11.5396C18.5099 11.0681 17.6666 11.4508 17.6666 12.1667V17.9982C17.6661 17.7682 17.5712 17.5385 17.382 17.3729L10.7153 11.5396C10.1765 11.0681 9.33325 11.4508 9.33325 12.1667V23.8334C9.33325 24.5494 10.1765 24.932 10.7153 24.4606L17.382 18.6272C17.5712 18.4617 17.6661 18.2319 17.6666 18.002ZM10.9999 21.9969L15.5678 18L10.9999 14.0032V21.9969ZM27.6666 24.6667H25.9999V11.3334H27.6666V24.6667ZM19.3333 14.0032L23.9011 18L19.3333 21.9969V14.0032Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLastCircle);
export default __webpack_public_path__ + "static/media/icon_last_circle.a7558a4f.svg";
export { ForwardRef as ReactComponent };